import React from 'react';
import type { TravelJournalArticlesTypeProps } from './types';
import HeroSection from './hero-section';
import Introduction from './introduction';
import ArticleGrid from './article-grid/ArticleGrid';
import CategoriesGrid from './categories-grid';

const Articles: React.FC<TravelJournalArticlesTypeProps> = ({
  articles,
  categories,
}) => {
  const articleBlocks = [];
  for (let i = 0; i < articles.length; i += 6) {
    articleBlocks.push(articles.slice(i, i + 6));
  }

  return (
    <main>
      <HeroSection categories={categories} />
      <Introduction />
      {/* Show first article grid */}
      {articleBlocks.length > 0 && <ArticleGrid articles={articleBlocks[0]} />}
      {/* Show second article grid if we have enough articles */}
      {articleBlocks.length > 1 && <ArticleGrid articles={articleBlocks[1]} />}
      {/* Show categories grid after first two article grids */}
      <CategoriesGrid categories={categories} />
      {/* Show remaining article blocks if any */}
      {articleBlocks.slice(2).map((block, index) => (
        <ArticleGrid key={index} articles={block} />
      ))}
    </main>
  );
};

export default Articles;
